<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
        <v-card-title>Change Tags</v-card-title>

        <v-card-text>
            <p>Select the tags you would like to apply by clicking them.  Selected tags are in <b>bold</b></p>
            <div
                style="line-height: 55px"
            >
                <v-chip
                    v-for="(item, index) in results"
                    :key="index"
                    :color="item.color"
                    style="margin-right: 5px;"
                    v-on:click="onClickChip(item)"
                >
                    <b
                        v-if="selected_tag_ids.includes(item.rc_tag_id)"
                    >
                        {{item.label}}
                    </b>

                    <span
                        v-else
                    >
                        {{item.label}}
                    </span>

                </v-chip>
            </div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onClickEditTags"
            >
            Edit Tags...
            </v-btn>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
            >
            Save
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            dialog: false,
            results: [],
            selected_tag_ids: [],
            on_save: () => {},
            organization_id: null,
        }
    },

    created () {
        this.$event_bus.$on('change_tags_dialog', this.showDialog);
    },

    beforeDestroy () {
        this.$event_bus.$off('change_tags_dialog',this.showDialog);
    },

    methods: {

        showDialog(params)
        {
            if ( params.applies_to == 'organization-origin' )
            {
                params.organization_id = '53485c43-8d64-4be9-82fa-6ae2b4efe575'; // The RedChirp organization...
            }

            this.selected_tag_ids = _.cloneDeep(params.selected_tag_ids);
            if ( this.selected_tag_ids == null ) this.selected_tag_ids = [];

            this.on_save = params.on_save == null ? () => {} : params.on_save;
            this.organization_id = params.organization_id;

            

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'LIST: /api/v1/rc-tags',
            
                {
                    'organization_id': params.organization_id,
                    'applies_to': { 'type': 'contains', 'value' : params.applies_to },
                    'is_archived': params.show_archived ? null : false,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.results = data.results;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get tags');
                },
            );

            this.dialog = true;
        },

        onClickChip(item)
        {
            if ( this.selected_tag_ids.includes(item.rc_tag_id) )
            {
                this.selected_tag_ids = this.selected_tag_ids.filter(a => a !== item.rc_tag_id);
            }
            else
            {
                this.selected_tag_ids.push(item.rc_tag_id);
            }
        },

        onOk()
        {
            this.dialog = false;
            this.on_save(this.selected_tag_ids);
        },

        onCancel()
        {
            this.dialog = false;
        },
        
        onClickEditTags()
        {
            this.$router.push({
                'name': 'settings-organization-tags',
                'params' : {
                    'organization_id': this.organization_id
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
</style>